export default "__VITE_ASSET__ChuVgo5Q__"